import type { Category } from "../types";

export default function getCategoriesWithoutCourses(categories: Category[]) {
  return categories.filter((category) => category.key !== "course");
}
